/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import classNames from 'classnames';
import { compose, withHandlers, withProps } from 'recompose';
import ReactOnClickOutside from 'react-onclickoutside';

import { INDETERMINATE } from './constants';
import withToggle from './hoc/withToggle';

const SelectWithIndeterminateInput = ({
  input: { value: inputValue, ...inputProps },
  wrapperClassName,
  triggerClassName,
  dropdownClassName,
  openedToggle,
  openedIsOn,
  options,
  selectedOption,
  handleOptionClick,
  // eslint-disable-next-line react/prop-types
  'data-automation-id': dataAutomationId,
}) => (
  <div className={classNames('c-multiselect', wrapperClassName)} data-automation-id={dataAutomationId}>
    <span
      className={classNames(
        'c-select',
        { 'is-active': openedIsOn },
        triggerClassName
      )}
      onClick={openedToggle}
      data-automation-id={`${dataAutomationId}-value`}
    >
      <span className="u-pr-">{inputValue === INDETERMINATE ? 'Varies' : selectedOption.label}</span>
    </span>
    <div
      className={classNames(
      'c-multiselect__dropdown',
        { 'is-active': openedIsOn }
      )}
      data-automation-id={`${dataAutomationId}-options`}
    >
      <div
        display-if={!options.length}
        className="u-co-gray-3 u-fontsize-extrasmall u-text-center u-p-"
      >
        No options available
      </div>
      <ul className={classNames('list-bare', dropdownClassName)}>
        {options.map(option => (
          <li
            className="c-select-option u-nowrap"
            key={`${inputProps.name}-${option.value}`}
            onClick={handleOptionClick(option.value)}
          >
            <span className={classNames({ 'is-transparent': option.value !== inputValue })}>
              &#x2713;&nbsp;
            </span>
            {option.label || option.value}
          </li>
        ))}
      </ul>
    </div>
  </div>
);

SelectWithIndeterminateInput.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.any,
    onChange: PropTypes.func,
  }).isRequired,
  wrapperClassName: PropTypes.string,
  triggerClassName: PropTypes.string,
  dropdownClassName: PropTypes.string,
  openedIsOn: PropTypes.bool.isRequired,
  openedToggle: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.any,
  })),
  selectedOption: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.any,
  }),
  handleOptionClick: PropTypes.func.isRequired,
};

SelectWithIndeterminateInput.defaultProps = {
  wrapperClassName: '',
  triggerClassName: '',
  dropdownClassName: '',
  options: [],
  selectedOption: {},
};


const SelectWithIndeterminateContainer = compose(
  withToggle('opened', false),
  withProps(props => ({
    selectedOption: props.options && props.options.length
      ? props.options.find(option => option.value === props.input.value)
      : { label: props.input.value.toString(), value: props.input.value },
  })),
  withHandlers({
    handleClickOutside: props => () => props.openedOff(),
    handleOptionClick: props => optionValue => () => {
      props.input.onChange(optionValue);
      props.openedOff();
    },
  }),
  ReactOnClickOutside,
);

const Input = SelectWithIndeterminateContainer(SelectWithIndeterminateInput);

const SelectWithIndeterminate = props => (
  <Field
    component={Input}
    {...props}
  />
);

export default SelectWithIndeterminate;
